import styled from 'styled-components';
import {
  NavLink,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  height: 80px;
  padding: 20px 30px;
  background-color: ${props => props.theme.colors.baseBanner};
`;

export const Tabs = styled(Flex).attrs({
  align: 'center',
  spacing: 10,
})`
  width: 100%;
  padding: 0 20px;
  border-bottom: 1px solid #dcdcdc;
`;

export const Tab = styled(NavLink).attrs({
  activeClassName: 'selected',
})`
  color: #9ea0a1;
  font-size: 1.6em;
  line-height: 44px;
  text-transform: capitalize;
  margin-bottom: -1px;
  border-bottom: 3px solid transparent;
  padding: 2px 0px;
  cursor: pointer;

  &.selected {
    color: ${props => props.theme.colors.primary};
    border-bottom-color: ${props => props.theme.colors.primary};
  }
`;

export const Product = styled(Flex).attrs({
  width: '100%',
  align: 'stretch',
})`
  flex: 1;
  justify-content: center;
  min-height: 190px;
`;

export const ProductImage = styled(Flex).attrs({
  flex: '0 0 35%',
})`
  min-width: 200px;
  max-width: 335px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  img {
    max-width: 100%;
  }
`;

export const ProductData = styled(Flex).attrs({
  grow: 1,
  spacing: 30,
  justify: 'space-between',
  padding: '15px 30px',
})`
  border: 1px solid #dcdcdc;
  border-left: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const ProductTitle = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: 1.6em;
  font-weight: 600;
  line-height: 44px;
`;

export const ProductPrice = styled(Flex).attrs({
  column: true,
  align: 'center',
  flex: '0 0 130px',
})`

  & > b {
    color: ${props => props.theme.colors.primary};
    font-size: 3.6em;
    font-weight: 600;
  }
`;
